import { render, staticRenderFns } from "./SujectName.vue?vue&type=template&id=03de1547&scoped=true&"
import script from "./SujectName.vue?vue&type=script&lang=js&"
export * from "./SujectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de1547",
  null
  
)

export default component.exports